import {Box} from '@mui/material'

import React from 'react'

import {useIsFetching, useIsMutating} from '@tanstack/react-query'

import logo from '@images/amplio-icon.png'

import {LoaderWrapper, StyledBackdrop, StyledProgress} from './style'

/**
 * Full screen Loader Overlay component
 */
export function LoaderOverlay() {
  const isFetching = useIsFetching()
  const isMutating = useIsMutating()

  const isLoading = isFetching > 0 || isMutating > 0

  return (
    <StyledBackdrop open={isLoading}>
      <LoaderWrapper>
        <StyledProgress size={70} thickness={2.5} />
        <Box
          component="img"
          src={logo}
          sx={{width: 35, height: 35, position: 'absolute', padding: 2.5, borderRadius: 999}}
        />
      </LoaderWrapper>
    </StyledBackdrop>
  )
}
